module.exports = (fox, _) => ({
  configure() {
    this.registerOptions("", {
      flashContainer: "#lst-container",
      template: "liveshow_palyer_container",
      "embed.container": "#liveshow-container",
      flashParams: {
        bgcolor: "#000000",
      },
      widgets: {
        "cbPaymentPopup.widget": "CBPaymentPopup",
        sidebarMain: {
          widget: "Widget",
          group: "sidebar",
          "embed.container": "#sidebar-container",
          template: "ls_viewer_sidebar_main",
          autoRender: true,
          handleDom: {
            tipModelBtn: {
              target: "#tip-model-btn",
              callback: () => {
                const tipme = this.wom1("#tipme");
                if (!tipme.isRendered()) {
                  tipme.render();
                }
                this._bindData.showTips = !this._bindData.showTips;
              },
            },
            toggleGiftBox: {
              target: "#toggle-gift-box",
              callback: () => this.toggleGiftBox(),
            },
          },
          hooks: {
            onStartRendering: function () {
              fox.each(
                this.getParent().connectParams,
                function (param, name) {
                  this.setTemplateOptions(name, param);
                },
                this
              );
              this.getParent()._bindData.showTips = false;
              var settings = this.getParent().settings || {};

              if (settings.showFanList === 0) {
                this.setTemplateOptions("hideFans", true);
              }

              this.wait("addedToDom").then(
                function () {
                  this.setTemplateOptions({});
                  this.getParent().updateFansAmount(
                    false,
                    this.rwom1("#tabFans")
                  );
                }.bind(this)
              );
            },
            onStopRendering: "@parent:toggleMessageBlock",
          },
          widgets: {
            tabs: {
              widget: "Tools_TabsSwitcher",
              target: ".ls-tabs .ls-tab-item",
              name: "tab-id",
              callback: "@parent @parent:switchTabs",
              switchOnEmbed: true,
            },
            tabFans: {
              widget: "LSFans",
              "embed.container": "#sidebar-main-container",
              template: "ls_viewer_sidebar_main_fan_list_container",
              "widgets.fanList": {
                "embed.container": "#fan-list-container",
                "tpl.row": "ls_viewer_sidebar_main_fan_list_row",
              },
              group: "sidebarTabs",
              active: false,
            },
            tabChat: {
              widget: "LSChatList",
              "embed.container": "#sidebar-main-container",
              autoRender: true,
              template: "ls_viewer_sidebar_main_chat_list_container",
              group: "sidebarTabs",
              scrollContainer: ".chat-list-scroll-wrapper",
              scrollTheme: "minimal",
              "widgets.chatList": {
                "tpl.row": "ls_viewer_sidebar_main_chat_list_row",
                "embed.container": "#chat-list-container",
              },
            },

            tabFakeChat: {
              widget: "FakeChatList",
              group: "sidebarTabs",
              active: false,
              getMemberInfo: (...args) => this.getMemberInfo(...args),
            },
          },
        },
        tipme: {
          widget: "Content_Tipme",
          "embed.container": "#tipme-form",
          template: "liveshow_content_tipme",
          "hooks.onShowSuccessPopup": this.onTipSuccessfully,
          "wrapMethods.renderConfirmContent": true,
          "hooks.onRenderConfirmContent": (to) => {
            const tcb = this.rwom1("#tipsConfirmBody");
            tcb.setTemplateOptions(to);

            if (tcb.isActive()) {
              tcb.render();
            } else {
              this.switchEmbeddedWidget("tipsConfirmBody");
            }
          },
          "widgets.confirmPopup": {
            "wrapMethods.show": true,
            "hooks.onShow": () => false,
          },
          "widgets.form.container": "@parent @parent #tipsConfirmBody",
        },
        giftBox: {
          widget: "Giftbox",
          group: "sidebar",
          "embed.container": "#sidebar-container",
          active: false,
          giftType: "liveshow",
          giftPaymentSuccess: "inboxSocketEventLiveshow:giftUnlock",
          targetIdCb: function () {
            return this.connectParams.sessionId;
          }.bind(this),
          handleDom: {
            closeGiftBox: {
              target: ".close-giftbox",
              callback: () => {
                this.toggleGiftBox();
              },
            },
          },
        },
        status: {
          widget: "Widget",
          "embed.container": "#splash-container",
          template: "liveshow_player_model_status",
          active: true,
          group: "playerSplash",
          autoRender: true,
        },
        error: {
          widget: "Widget",
          "embed.container": "#overlay-container",
          autoRender: true,
          template: "liveshow_player_overlayed_error",
          group: "playerOverlay",
          active: false,
          handleDom: {
            refreshPage: {
              event: "click",
              target: "#refresh-page",
              callback: function () {
                window.location.reload();
              },
            },
            restartLiveshow: {
              event: "click",
              target: "#restart-liveshow",
              callback: fox.bind(function () {
                delete this.inst;
                this.dispatchEvent("restartLiveshow");
              }, this),
            },
          },
        },
        paidEntry: {
          widget: "Widget",
          "embed.container": "#overlay-container",
          autoRender: true,
          template: "liveshow_player_overlayed_paid_entry",
          group: "playerOverlay",
          active: false,
          handleDom: {
            acceccGranted: {
              event: "click",
              target: "#entry-resume",
              callback: this.entryAccessGranted.bind(this),
            },
          },
        },

        paidShowConfirmBody: {
          widget: "Widget",
          autoRender: true,
          template: "ls_viewer_sidebar_paidrequest_confirm",
          group: "sidebar",
          active: false,
          "embed.container": "#sidebar-container",
          handleDom: {
            confirm: {
              event: "click",
              target: "#confirm-paid",
              callback: (...args) => this.privateShowConfirmed(...args),
            },
            decline: {
              event: "click",
              target: "#cancel-paid",
              callback: () => this.switchEmbeddedWidget("sidebarMain"),
            },
          },
        },
        tipsConfirmBody: {
          widget: "Widget",
          autoRender: true,
          template: "ls_viewer_sidebar_tip_confirm",
          group: "sidebar",
          active: false,
          "embed.container": "#sidebar-container",
          handleDom: {
            confirm: {
              target: "#confirm-tip",
              callback: (btn) => {
                new fox.Promise((resolve) => {
                  $(btn).addClass(_.DOM_CLASS_SPIN);
                  this.rwom1("#tipme").submit(resolve);
                }).then((result) => {
                  $(btn).removeClass(_.DOM_CLASS_SPIN);
                  return result && this.switchEmbeddedWidget("sidebarMain");
                });
              },
            },
            decline: {
              target: "#cancel-tip",
              callback: () => {
                this.switchEmbeddedWidget("sidebarMain");
              },
            },
          },
        },
        privateControl: {
          widget: "Widget",
          "embed.container": "#private-control-container",
          active: false,
          autoRender: true,
          template: "ls_private_control",
        },
        "liveshowGoal.widget": "ClientLSGoal",
        "authorizePopup.widget": "Common_AutoLoginPopup",
      },
      handleDom: {
        toggleFullscreen: {
          target: "#toggle-fullscreen",
          callback: "toggleFullscreen",
        },
        closeFullscreenOnEsc: {
          event: "keydown",
          target: document,
          targetWidget: "@root",
          eventChecker: fox.bind(function (e) {
            return this.fullscreen === true && e.keyCode === 27;
          }, this),
          callback: function () {
            var el = this.dom1("#toggle-fullscreen");

            this.toggleFullscreen(el);
          },
        },
        volumeChange: {
          target: ".volume-slider",
          callback: "volumeChange",
        },
        volumeOff: {
          target: ".ls-iconvol",
          callback: function (icon) {
            var $btn = $(icon).parent();
            var value = 0;

            if ($btn.hasClass("disabled")) return false;

            if (!$btn.hasClass("muted")) {
              this.previosVolumeValue = this.controller.getVolume() * 100;
            } else {
              value = this.previosVolumeValue || 50;
            }

            this.controller.setVolume(value);
            this.setUiVolumeLevel(value);
          },
        },

        sendMessageOnBtn: {
          target: _.DOM_SELECTOR_SENDMESSAGEBTN,
          targetWidget: "#sidebarMain",
          callback: "sendMessageToChat",
        },
        sendMessageOnEnter: {
          event: "keydown",
          target: "#message-body",
          targetWidget: "#sidebarMain",
          eventChecker: function (e) {
            return e.keyCode === 13;
          },
          callback: "sendMessageToChat",
        },
        paidRequest: {
          target: "#paid-request",
          targetWidget: "#privateControl",
          callback: () => this.showPaidConfirm(),
        },
        paidLeave: {
          target: "#paid-leave",
          targetWidget: "#privateControl",
          callback: () => this.leaveLiveshow(),
        },
        requestPrivateFromNotAllowed: {
          target: "#request-private",
          callback: () => this.showPaidConfirm(),
        },
      },
      handleWom: {
        updateFansAmount: {
          event: "fansAmountChanged",
          widget: ".Widget .LSFans",
          callback: "updateFansAmount",
        },
        giftSended: {
          event: "giftSended",
          widget: "#giftBox",
          callback: "giftSended",
        },
        giftPaid: {
          event: "giftPaid",
          widget: "#giftBox",
          callback: "giftPaid",
        },
        sendToUser: {
          event: "sendToUser",
          widget: ".Widget .LSFans",
          callback: "sendToUser",
        },
        settingsChanged: {
          widget: "@root #socket",
          event: "inboxSocketEventLiveshow:newSettings",
          callback: (settings) => {
            if (this.isDisconnected()) return false;

            if (settings.answer) settings = settings.answer;

            if (settings.id !== this.connectParams.sessionId) return false;

            if (this.isAllowed(settings.allowedGroups) && this.isAllowed())
              return this.setLiveshowSettings(settings);

            this.controller.release();
            this._resetStates();
            this.setLiveshowSettings(settings);
            this.app_initialized();
          },
        },
        publicMessageRecieve: {
          event: "inbox_public",
          widget: "@root #uchatctrl",
          callback: "setChatMessage",
        },
        privateMessageRecieve: {
          event: "inbox_private",
          widget: "@root #uchatctrl",
          callback: "onChatPrivateMessage",
        },
        onRoomLeave: {
          event: "roomLeave",
          widget: ".Widget .LSFans",
          callback: function (user) {
            if (user.uid == fox.getEnv("site.clientId")) {
              this.dispatchEvent(_.EVENT_LIVESHOWISOVER);
            }
          },
        },
      },
    });

    ["statusDone", "statusPrivate", "error", "statusInprogress"].forEach(
      (alias) => {
        this.registerOptions(`#${alias}`, {
          "wrapMethods.deactivate": true,
          "hooks.onStartDeactivate": function () {
            this.removeFromDom();

            return true;
          },
        });
      }
    );

    this.callParent("configure", arguments);
  },
});



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/mixins/translatorConfigure.es.js